$(document).ready(function() {
  

$('.testimonials-list').slick({
  prevArrow:`<button type="button" class="slick-prev"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
</path></svg></button>`,
  nextArrow:`<button type="button" class="slick-next"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
</path></svg></button>`
});

$('.tv-video .play-btn').on('click', function() {
  $(this).next('video')[0].play();
  $(this).parents('.testimonials-image-video').toggleClass('video-playing');
})


$('.scroll-down').on('click', function() {
  var scroll_height = $(this).parents('.banner').height() - $('.header-wrapper').outerHeight();
  $('html, body').animate({
     scrollTop: scroll_height
 }, 1000);
})


})


// window.addEventListener("DOMContentLoaded", (event) => {
//   if (window.location.pathname.indexOf('/products/') !== -1) {
//     if(document.querySelectorAll("#wholesaleAddToCart").length > 0){
      
//       var eventSelector = {
//         _divWholesaleVariantId: document.querySelectorAll(".wholesale-variant-id"),
//         _wholesaleAddToCartBtn: document.querySelector("#wholesaleAddToCart"),
//         _wholesaleQtyIncDecBtn: document.querySelectorAll(".wholesale-quantity-increase-decrease"),
//         _wholesaleQtyInput: document.querySelectorAll(".prod_qty")
//       }
      
//       window.wholesaleBundle = {
//         _init : function(){
//           this._eventBinder();
//         },
//         _eventBinder: function(){
//           eventSelector._wholesaleAddToCartBtn.addEventListener("click", this._getVariantsDetails.bind(this), true);
//           eventSelector._wholesaleQtyIncDecBtn.forEach(el => {
//             el.addEventListener("click", this._incDecCounter.bind(this), true)
//           });
//           eventSelector._wholesaleQtyInput.forEach(el => {
//             el.addEventListener("input",function(e){
//               if(e.target.value > 0){
//                 window.wholesaleBundle._getQuerySelectorData(false, e.target.parentNode,"price").innerHTML = `$${window.wholesaleBundle._updatePrice(e.target.value)}`;
//               }
//             }, true);
//           })
//         },
//         _getQuerySelectorData: function(all = false, element, selector){
//           return all ? element.querySelectorAll(selector) : element.querySelector(selector);
//         },
//         _incDecCounter: function(event){
//           let currentParentNode = event.target.parentNode;
//           let inputEl = this._getQuerySelectorData(false, currentParentNode, 'input.prod_qty');
          
//           // let price = currentParentNode.dataset.variantprice;
//           let priceEl = this._getQuerySelectorData(false, currentParentNode, 'price');
          
//           let currentValue = parseInt(inputEl.value);
//           let updatedVal = "";
//           if(event.target.dataset.plus_minus == "plus"){
//             updatedVal = currentValue + 1; 
//             inputEl.value = updatedVal;
//             // priceEl.innerHTML = `$${ (price * updatedVal).toFixed(2) }`;
//             var UpdatedPrice = this._updatePrice(updatedVal);
//             priceEl.innerHTML = `$${UpdatedPrice}`;
//           }
//           if(event.target.dataset.plus_minus == "minus"){
//             if(currentValue != 1 && currentValue > 1 ){
//               updatedVal = currentValue - 1;
//               inputEl.value = updatedVal;
//               // priceEl.innerHTML = `$${ (price * updatedVal).toFixed(2) }`;
//               var UpdatedPrice = this._updatePrice(updatedVal);
//               priceEl.innerHTML = `$${UpdatedPrice}`;
//             }
//           }
         
//         },
//         _updatePrice: function(qtyRange){
//           let volumeTires = this._getQuerySelectorData(true, document, '.hulkapps-volume-discount-tiers table tbody tr');
//           let ranges = [];
//           volumeTires.forEach(el => {
//             var col = this._getQuerySelectorData(false, el, 'td');
//             var colPrice = this._getQuerySelectorData(false, el, 'td .hulkapps-price .money');
//             var colText = col.innerText;
//             var colPrice = colPrice.innerText.replace("$", "");
//             ranges[col.innerText] = [colText, colPrice];
//           })
//           rangePrice = this._getPrice(qtyRange, ranges);
//           return rangePrice;
//         },
//         _getPrice: function(number, ranges) {
//           for (let range in ranges) {
//             if (range.includes('+')) {
//               const minNumber = parseInt(range.slice(0, -1));
//               if (number >= minNumber) {
//                 return ranges[range][1];
//               }
//             } else {
//               const [min, max] = range.split('-').map(Number);
//               if (number >= min && number <= max) {
//                 return ranges[range][1];
//               }
//             }
//           }
//           return null; // Return null if no matching range found
//         },
//         _getVariantsDetails: function(event){
//           var arrVariantIds = [];
//           eventSelector._divWholesaleVariantId.forEach(el => {
//             var variantId = parseInt(el.getAttribute("data-variant-id"));
//             arrVariantIds[variantId] = {
//               "varId": variantId,
//               "quantity": this._getQuerySelectorData(false, document, `.wholesale--${variantId} .prod_qty`).value
//             };
//           });
//           this._generateJsonString(arrVariantIds);
//         },
//         _generateJsonString: function(arrVariantIds){
//           let formData = {};
//           formData['items'] = [];
//           for (var variantId in arrVariantIds) {
//             var entry = {
//               'id': arrVariantIds[variantId].varId,
//               'quantity': arrVariantIds[variantId].quantity
//             };
//             formData['items'].push(entry);
//           }
//           this._addProductToCart(formData);
//         },
//         _addProductToCart: function(jsonFormData){
//           fetch(window.Shopify.routes.root + 'cart/add.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(jsonFormData)
//           })
//           .then(response => {
//             return response.json();
//           })
//           .then(response => {
//             window.location.href = "/cart";
//           })
//           .catch((error) => {
//             console.error('Error:', error);
//           });
//         }
//       }
      
//       window.wholesaleBundle._init();

//       const checkDiv = setInterval(() => {
//         if(document.querySelectorAll('.hulkapps-volume-discount-tiers').length > 0) {
//           document.querySelector('.hulkapps-volume-discount-tiers').style.display = "none";
//           clearInterval(checkDiv);
//           document.querySelectorAll(".prod_qty").forEach(elem => {
//             var priceE = elem.parentNode.querySelector("price");
//             priceE.innerHTML = `$${window.wholesaleBundle._updatePrice(elem.value)}`;
//             priceE.style.visibility = "visible";
//             priceE.style.opacity = "1";
//           })
//         } 
//       }, 100); 
      
//     }
//   }
// });


// faq section accordion
  $(".question").click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.answer').slideUp();
      $('.question').not(this).removeClass('active');
      $('.faq-inbox').removeClass('activeToggle');
      $(this).addClass('active');
      $(this).next('.answer').slideDown();
      $(this).parent().addClass("activeToggle"); 
    } else {
      $(this).removeClass('active');
      $(this).next('.answer').slideUp();
      $(this).parent().removeClass("activeToggle"); 	
    }
  });

// $('#header_search').on('submit', function(event) {
//     event.preventDefault();
//     var token = grecaptcha.getResponse();
    
//     if(token) {
//         $.ajax({
//             url: 'https://www.google.com/recaptcha/api/siteverify',
//             type: 'GET',
//             data: {
//                 secret: '6LeZJKUpAAAAACBDdh4eV-SgZD-T2aNWWjZEssP0',
//                 response: token
//             },
//             success: function(response) {
//                 if(response.success) {
//                     // reCAPTCHA verified, proceed with form submission
//                     $('#header_search').submit();
//                 } else {
//                     // reCAPTCHA validation failed
//                     alert('reCAPTCHA validation failed');
//                 }
//             }
//         });
//     } else {
//         // reCAPTCHA token not found
//         alert('Please complete the reCAPTCHA');
//     }
// });
$(document).ready(function() {

         var actCallback = function (response) {
        
    $('#header_search_button').prop("disabled", false);
        
    $('#re-captcha').remove();
        
  };
        
  var expCallback = function() {
        
    $('#header_search_button').prop("disabled", true);
        
  };
        
  var onloadCallback = function () {
        
    if ( $('#re-captcha').length ) {
      console.log(123);
    grecaptcha.render(document.getElementById('re-captcha'), {
        
      "sitekey" : "6LeZJKUpAAAAACBDdh4eV-SgZD-T2aNWWjZEssP0",
        
      "theme": "light",
        
      "callback" : function (response) {
        
    $('#header_search_button').prop("disabled", false);
        
    $('#re-captcha').remove();
        
  },
        
      "expired-callback": function() {
        
    $('#header_search_button').prop("disabled", true);
        
  }
        
        
  }
    )
  }
  }

// onloadCallback();
})
